exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/_wks-ext.js
// module id = 66
// module chunks = 0